export default __webpack_public_path__ + "static/media/bg-player-default.6179ece7.jpg";